import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCropperComponent } from './component/image-cropper/image-cropper.component';
import { ControlImageCropperComponent } from './component/control-image-cropper/control-image-cropper.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


/** https://stackblitz.com/edit/image-cropper?file=app%2Fimage-cropper%2Fcomponent%2Fimage-cropper.component.ts **/
@NgModule({
    exports: [
        ImageCropperComponent,
        ControlImageCropperComponent
    ],
    imports: [
        CommonModule,
        FormsModule, TranslateModule,
        ImageCropperComponent,
        ControlImageCropperComponent
    ]
})
export class ImageCropperModule {
}
